// extracted by mini-css-extract-plugin
export var modal = "_5c-0";